import axios from 'axios';

const getToken = () =>{
    let payload = JSON.parse(sessionStorage.getItem('chatStorage'));
    return payload.user.token;
}

const Login = async user =>{
    try {
        const response = await axios.post(`/login`, user );
        return response.data;
    } catch (error) {
        return error;
    }
}

const Register = async user =>{
    try {
        const response = await axios.post(`/register`, user);
        return response.data;
    } catch (error) {
        return error;
    }
}

const getUsers = async () =>{
    try{
        const response = await axios.get(`/users`, {headers:{'Authorization': `Bearer ${getToken()}`}});
        return response.data; 
    }catch(err){
        return err;
    }
}

const getUserById = async id =>{
    try{
        const response = await axios.get(`/user/id/${id}`, {headers: {'Authorization': `Bearer ${getToken()}`}});
        return response.data;
    } catch(error){
        return error;
    }
}; 

const updateUser = async user =>{
    try {
        const response = await axios.patch(`/user`, user, {headers: {'Authorization': `Bearer ${getToken()}`}} );
        return response.data;
    } catch (error) {
        return error;
    }
};

const updateUserEnabled = async (id, enabled)=>{
    try{
        const response = await axios.patch(`/user/status`, {id, enabled}, {headers:{'Authorization': `Bearer ${getToken()}`}});
        return response.data;
    }catch(err){
        return err;
    }
}

const deleteUser = async email => {
    try {
        const response = await axios.delete(`/user/${email}`, {headers:{'Authorization': `Bearer ${getToken()}`}});
        return response.data;
    } catch (error) {
        return error;
    }
}

const user = { Login, Register, getUsers, getUserById, updateUser, updateUserEnabled, deleteUser }

export default user